/**
* In Add Parent function is used to add or create new parent details and it's functions declare this file
**/
import {useParams,Link,useNavigate,useLocation} from 'react-router-dom';
import { useState,useEffect,useRef} from 'react';
import * as Yup from 'yup';
import { validate } from '../../../services/ValidationService';
import ApiService from '../../../services/ApiService';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ImageCroper from '../../../shared/modals/ImageCroper'
import { dataURItoBlob,filterGeoLocation,convertS3privateToPublic,goBack,convertTimeFormat,flatPickerFormatDate } from '../../../services/UtilsService';
import { toast } from 'react-toastify';
import Autocomplete from 'react-google-autocomplete';
import Select from 'react-select';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';

function EditChildren(){
	//Intial state declaration
	const { id } = useParams();
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const [isValid,setValid]=useState(true);
	const navigate = useNavigate();
	const [show,SetShow]=useState(false);
	const [image, setImage] = useState('');
	const [cropImge, setCropImage] = useState();
	const [tab,setTab]=useState(0);
	const [physicianInfo,setPhysicianInfo]=useState([]);
	const [workSchedules, setWorkSchedules] = useState([]);
	const [filteredSchedules, setFilteredSchedules] = useState([]);
	const location = useLocation();
	const { memberId } = location.state || {};
	const dobflatpickrRef = useRef(null); // Create a ref for Flatpickr
	const eddflatpickrRef = useRef(null); // Create a ref for Flatpickr
	const { t } = useTranslation();

	// useEffect(() => {
	// 	setTimeout(() => {
	// 	  // This will trigger the re-render after a slight delay
	// 	  setData((prevData) => ({ ...prevData }));  // Force update
	// 	}, 50);  // Delay of 50ms (you can adjust this)
	//   }, [data]);  // Trigger effect when data is updated

	const hasRunOnce = useRef(false); // Ref to track if useEffect has run before

	useEffect(() => {
	  if (!hasRunOnce.current) {
		// First run of the useEffect
		setTab(1);
  
		setTimeout(() => {
		  setTab(0);
		}, 500);
  
		hasRunOnce.current = true; // Mark as executed
	  }
	}, [data]); // `data` will only trigger the effect the first time
	  

	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	//callback function
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
		  fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	  };
	const imageData= (data)=> setCropImage(data)

    /** 
	* Validation schema for Parent Fields
	* @first_name - required field and pass the parent first_name
	* @last_name - required field and pass the parent last_name
	* @members - required field and pass the parent members
	* @email - required field and should be in correct parent email format 
	* @mobileNumber - required field and pass the parent mobileNumber
	* @city - required field and pass the parent city 
	* @state - required field and pass the parent state 
	* @gender - required field and pass the parent gender 
	* @zipcode - required field and pass the parent zipcode 
	**/
    const fields = [
		{ name: 'child_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'child_dob', validation: Yup.string().required(t('error.required')) },
		{ name: 'child_isPremature', validation: Yup.boolean().required(t('error.required')) },
		{
			name: 'child_expected_dob',
			validation:
				data.child_isPremature === 'true'
				? Yup.string()
				.required(t('error.required'))
			: Yup.string(),
		},
		{ 
			name: 'child_premeture_week', 
			validation:
			// data.child_isPremature === 'true'
			// ? Yup.string()
			// .test('Invalid number', constantVariables.error.numberOnly, (value) => {
			//   return /^\d+$/.test(value);
			// })
			// .required(constantVariables.error.required)
		   Yup.string(),
		},
		{ name: 'child_gender', validation: Yup.string().required(t('error.required'))},
		{
			name: 'child_blood_group', validation: Yup.string()
		},
		{ name: 'child_notes', validation: Yup.string() },
		{ name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
		{
			name: 'members',
			validation: Yup.string()
				.matches(/^\d+$/, t('error.numberFormat'))
				.required(t('error.required'))
		},
		{ name: 'email', validation: Yup.string().test('Invalid email address', t('error.email'), (value) => { return emailPattern.test(value); }).required(t('error.email')) },
		{ name: 'mobileNumber', validation: Yup.string() },
		{ name: 'city', validation: Yup.string() },
		{ name: 'gender', validation: Yup.string() },
		{ name: 'state', validation: Yup.string() },
		{
			name: 'zipcode',
			validation: Yup.string().trim()
			  .nullable() // Allows the field to be nullable
			  .matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number format
			//   .test('len', constantVariables.error.zipcode, function (value) {
			// 	return !value || value.length >= 5; // Only check length if value is not empty
			//   })
		  },
		  
    ];
		useEffect(() => {
			(async () => {
				if (id) {
					try {
						const response = await ApiService.getParentDetails(id); // Assuming the API uses the ID from the URL
	
						if (response.status === 200 && response.data) {
							const { parentInfo, memberInfo, physicianProfiles, workSchedules, physicianMapped } = response.data;
							let selectedMemberData = await memberInfo.filter(member => member.id === memberId); // Filter memberInfo array and store result in selectedMemberData
							console.log("selectedMemberData",selectedMemberData);
							if (selectedMemberData.length === 0 && memberInfo.length === 1) {
								selectedMemberData[0] = await memberInfo[0]; // If selectedMemberData is empty and memberInfo has only one object, assign that object
								console.log("selectedMemberData[0]",selectedMemberData[0])
							}
							// Populate parent details into the form
							setData({
								child_id: selectedMemberData[0].id,
								child_name: selectedMemberData[0].name || '',
								child_dob: selectedMemberData[0].dob || '',
								child_expected_dob:  selectedMemberData[0]?.delivery_date || '',
								child_premeture_week: selectedMemberData[0].premature_weeks === 0 ? "0" : selectedMemberData[0].premature_weeks || '',
								child_isPremature: selectedMemberData[0].isPremature === true ? "true" : "false",
								child_gender: selectedMemberData[0].gender === 0 ? "0" : "1" ,
								child_blood_group: selectedMemberData[0].blood_group || '' ,
								child_notes: selectedMemberData[0].description || '' ,
								first_name: parentInfo.first_name || '',
								last_name: parentInfo.last_name || '',
								countryNameCode: parentInfo.countryNameCode || '',
								email: parentInfo.email || '',
								gender: parentInfo.gender !== null && parentInfo.gender !== undefined ? parentInfo.gender.toString() : '',
								mobileNumberWithCode: `${parentInfo.countryCode} ${parentInfo.mobileNumber}` || '',
								address_one: parentInfo.address_one || '',
								address_two: parentInfo.address_two || '',
								members: parentInfo.members || '',
								city: parentInfo.city || '',
								state: parentInfo.state || '',
								physicianId: physicianMapped || '',
								photo: selectedMemberData[0].photo
							});

							
							// Check and set zipcode if not null
							if (parentInfo.zipcode !== null) {
								setData(prevData => ({
									...prevData,
									zipcode: parentInfo.zipcode
								}));
							}
							// Set physicians and work schedules
							setPhysicianInfo(physicianProfiles || []);
							setWorkSchedules(workSchedules || []);
							const filtered = workSchedules.filter(schedule => schedule.physician === physicianMapped);
							setFilteredSchedules(filtered);
						}
					} catch (error) {
						console.error("Error fetching parent details:", error);
					}
				}
			})();
		}, [id,memberId]);

		// Update `child_expected_dob_min` if `child_dob` is already set
		useEffect(() => {
			if (data.child_dob) {
				const nextDay = new Date(data.child_dob);
				nextDay.setDate(nextDay.getDate() + 1);
				setData((prevData) => ({
				...prevData,
				child_expected_dob_min: nextDay.toISOString().split("T")[0],
				}));
				console.log("datttatatatata",data);
			}
		}, [data.child_dob]);

   /** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
  const handleChange=async(e)=>{
	const { name , value } =e.target;
	//e.preventDefault();
	setData({...data,[name]:value});
	// Format value using Flatpickr's format function
	let updatedValue = value ;

	// Update state based on the field name
	if (name === "child_dob" || name === "child_expected_dob") {
		updatedValue = flatPickerFormatDate(value);
	}	

	if (name === "child_dob") {
        setData((prevData) => ({
            ...prevData,
            child_dob: updatedValue,
            child_expected_dob: "", // Reset Expected Delivery Date
            child_premeture_week: "", // Reset Number of Weeks Premature
        }));

        // Dynamically update minDate for Expected Delivery Date
        const dob = new Date(updatedValue);
        dob.setDate(dob.getDate() + 1); // Add one day
        const nextDayFormatted = dob.toISOString().split("T")[0];
        setData((prevData) => ({
            ...prevData,
            child_expected_dob_min: nextDayFormatted, // Update minDate dynamically
        }));
		
		const Errors = await validate({ [name]: value }, fields);
		setError({...error,[name]:Errors[name]});

        return; // Exit the function early since no further processing is needed
    }

    const updatedData = {
        ...data,
        [name]: updatedValue,
    };
    setData(updatedData); // Update the state

	const Errors = await validate({ [name]: value }, fields);
	setError({...error,[name]:Errors[name]});

	if (name === 'physicianId') { // Filter workSchedules based on selected physician ID
		const filtered = workSchedules.filter(schedule => schedule.physician === value);
		setFilteredSchedules(filtered);
	}
	// If DOB and Delivery Date are selected, calculate premature weeks
    if (name === "child_expected_dob" && data.child_dob) {
        const dob = new Date(data.child_dob);
        const deliveryDate = new Date(value);

        // Calculate the difference in days and convert to weeks
        const diffTime = Math.abs(deliveryDate - dob);
        const actualWeeks = Math.floor(diffTime / (7 * 24 * 60 * 60 * 1000)); // Weeks between dates
        
        // Subtract from 40 weeks to get premature weeks
        const prematureWeeks = Math.max(40 - actualWeeks, 0); // Ensure no negative values

        setData((prevState) => ({
            ...prevState,
            child_premeture_week: prematureWeeks.toString(), // Set calculated weeks
        }));
    }
	};

	/** 
	 * To handle submit event 
	 * @e - we get the event details from the form submit action
	 **/
	const handleSubmit=async(e)=>{
		const hospitalId = localStorage.getItem("userId");
		e.preventDefault();
		const Errors = await validate(data, fields);
		setError(Errors);
		const requiredFieldsForTab0 = ['child_name', 'child_dob', 'child_isPremature', 'child_expected_dob', 'child_premeture_week', 'child_gender', 'child_blood_group','child_notes']; // List of fields that need to trigger setTab(0) if they have errors
		const hasErrorsInTab0 = requiredFieldsForTab0.some(field => Errors[field]); // Check if any of the required fields have errors
		if (hasErrorsInTab0) { // If there are errors in any of the specified fields, move to setTab(0)
			setTab(0);
		} else {
			const otherFields = Object.keys(Errors).filter(field => !requiredFieldsForTab0.includes(field));
			if (otherFields.length > 0) { // If there are errors in other fields, move to setTab(1)
			  setTab(1);
			}
		}
		// Proceed if there are no validation errors and valid is true
		if (!Object.keys(Errors).length && isValid) {
			try {
				var fileResponse;
				var response;
				if (cropImge !== undefined) {
					const formData = new FormData();
					const fileConvertData =await dataURItoBlob(cropImge);
					formData.append('file', fileConvertData);
					fileResponse = await ApiService.uploadNewPhoto(response?.data?.orgId,formData);
				}

				  // Prepare the memberInfo and handle premature check
				  const memberInfo = {
					id: data.child_id || '',
					name: data.child_name || '',
					dob: data.child_dob || '',
					isPremature: data.child_isPremature || "false",
					delivery_date: data.child_isPremature === "false" ? null : data.child_expected_dob || '',
					premature_weeks: data.child_isPremature === "false" ? null : data.child_premeture_week || 0,
					gender: data.child_gender || '',
					blood_group: data.child_blood_group || '',
					description: data.child_notes || '',
					photo: fileResponse?.data?.filesName,
				};

				console.log("data  -> ",memberInfo);

				const payload = { // Prepare the payload in the expected format
					parentInfo: {
						account: id,
						first_name: data.first_name || '',
						last_name: data.last_name || '',
						email: data.email || '',
						mobileNumber: data.mobileNumber || '',
						members: data.members || 1,
						address_one: data.address_one || '',
						address_two: data.address_two || '',
						city: data.city || '',
						state: data.state || '',
						countryCode: data.countryCode || '',
						countryNameCode: data.countryNameCode || '',
						zipcode: data.zipcode || null,
						gender: data.gender === "" ? null : data.gender,
					},
					memberInfo: [memberInfo],
					physicianInfo: [
						{
							hospitalAdmin: hospitalId,
							physician: data.physicianId || '', // Physician ID from form
						}
					],
					updated_by: hospitalId
				};
				// Call the API to create a parent
				response = await ApiService.updateParentAndUpdateMember(payload);
				// If the response is successful
				if (response.status === 200) {
					toast.success(response?.data?.message);
					navigate('/hospital/admin/children');
				} else {
					// Handle any errors from the API
					toast.error(response?.data?.message || 'Something went wrong');
				}
			} catch (error) {
				// Handle any unexpected errors
				console.error(error);
				toast.error('An error occurred. Please try again.');
			}
		}
	};

	/** 
	* To check phone number valid or not 
	* @value - we pass the actual phone number
	* @country - we pass the countryCode
	* @e - we get the event details from the onChange action
	* @formattedValue - we pass the country formatted Value
	**/
	const handlePhone = async (value, country, e, formattedValue) => {
		const { format, dialCode } = country;
		setData({ ...data, [e.target.name]: formattedValue.split("+" + dialCode + " ")[1], countryCode: '+' + dialCode, countryNameCode: country?.countryCode });
		const Errors = await validate({ [e.target.name]: formattedValue }, fields);
		setError({ ...error, [e.target.name]: Errors[e.target.name] });

		if (!formattedValue || (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
			setValid(true);
		} else {
			setValid(false);
		}
	}

	/** 
	* To change city input 
	* @e - we get the event details form the change action
	**/
	const changeCity = async (e) => {
		const { value } = e.target;
		var obj = {};
		if (value.trim().length === 0) {
			obj = { city: '', state: '' };
		} else {
			obj = { city: value };
		}
		setData((data) => ({ ...data, ...obj }));
		const Errors = await validate({ city: value }, fields);
		setError({ ...error, city: Errors['city'] });
	}

	/** 
	* To select city input 
	* @e - we get the event details from the Select action
	**/
	const selectCity = async (e) => {
		var location = await filterGeoLocation(e);
		await setData((data) => ({ ...data, ...location }));
	}

	  /** To go to next page 
  * @tab - pass the selected tab value 
  * @e - we get the event details from the click action
  **/
	  const goNext=(tab)=>async(e)=>{
		e.preventDefault();
		if(tab===0){
		  const childFields = fields.filter(field => field.name.startsWith('child_')); // Filter out fields that start with 'child_'
		  const Errors = await validate(data, childFields); // Validate only child fields
		  setError(Errors);
		  if(!Object.keys(Errors).length && isValid){
			  setTab(1);
		  }
		} else if(tab===1){
			const Errors = await validate(data, fields);
			setError(Errors);
			if(!Object.keys(Errors).length && isValid){
				setTab(2);
			}
		}
	};

  /** 
  * To handle the image change
  * @e - we get the event details from the input file select action
  **/
	  const handleFile=async (e)=>{
		e.preventDefault();
		const file = e.target.files[0];
		openCropModal(file);
  
	}
	
	/** 
	* To open the image crop modal
	* @file - we pass the image details in the base 64 bit format
	**/
	const openCropModal=async(file)=>{
		
		if(file){
		   let ext = file.name.split('.').pop();
		   let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		   if (!allowedExtensions.includes(ext)) {
				  toast.error(t('error.fileFormat'));
				  await SetShow(false);
				   return;
			  }
		  if (file.size > 100 * 1024 * 1024) {
			  toast.error(t('error.fileSize'));
				  await SetShow(false);
				   return;
		  }
		   const reader = new FileReader();
		   reader.onload = () => { setImage(reader.result) };
		   reader.readAsDataURL(file);
		   await SetShow(true);
	   }else{
		   await SetShow(false);
	   }
	}
	
	/** 
	* To handle event drag
	* @e - we get the event details from the drag over action
	**/
	const handleDrag=(e)=>{
		e.preventDefault();
	}
	
	/** 
	* To handle event drop
	* @e - we get the event details from the drop over action
	**/
	const handleDrop=(e)=>{
		e.preventDefault();
		 const { files } = e.dataTransfer;
		 openCropModal(files[0]);
	}

	 return (
        <main id="main" className="main">
 		{/*import ImageCroper*/}
		<ImageCroper 
				show={show} 
				handleClose={handleClose}
				image={image}
				cropImge={imageData}
			/>
		{/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('profile.childInfo')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/hospital/admin/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item"><Link to='/hospital/admin/children'>{t('sidebar.children')}</Link></li>
					  <li className="breadcrumb-item active">{t('profile.childInfo')}</li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}	
		{/*Page Content Section*/}
		<section>			
			<div className="row">
				{/* <!--ProfileImg--> */}
				<div className="col-lg-3">
					<div className="card profile-img">
						<div className="card-body">
							<div className="upload-box d-none d-lg-block">		
								<div className="box text-center"  onDrop = {handleDrop} onDragOver = {handleDrag}>
									<input type="file" onChange={handleFile} name="file-6[]" id="file-6" className="inputfile inputfile-4"  />
									<label htmlFor="file-6">
									{cropImge && (<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
									{(!cropImge && data && data?.photo && data?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="IMG" />}
									{(!cropImge && data && data?.photo && data?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
										<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
									</label>
								</div>
							</div>
							<div className="text-center text-tmAquaGreen mt-4">
							<h6>{t('profile.uploadPicture')}</h6>
							</div>
						</div>
					</div>
				</div>
				{/* <!--ProfileInfo--> */}
				<div className="col-lg-9">
					<div className="card form-card profile-info admin-profile-info">
						<div className="card-body pt-4">
						<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
								<li className="nav-item" role="presentation">
									<span onClick={()=>setTab(0)} className={tab===0?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.childInfo')}</span>
								</li>
								<li className="nav-item" role="presentation">
									<span onClick={()=>setTab(1)}  className={tab===1?"nav-link active":"nav-link"} type="button" role="tab">{t('profile.parentInfo')}</span>
								</li>
								<li className="nav-item" role="presentation">
									<span onClick={()=>setTab(2)}  className={tab===2?"nav-link active":"nav-link"} type="button" role="tab">{t('profile.physicianInfo')}</span>
								</li>
						</ul>
							<div className="tab-content">						

								{/* <!--TAB-01--> */}						
								{tab===0 && <div>
									<form autoComplete="off">
										<div className="row">
											<div className="col-lg-6 col-md-12">
												<div className=" form-group">
													<label>{t('profile.childName')}</label>
													<input onChange={handleChange} value={data.child_name?data.child_name.trim():''} name="child_name" type="text" className="form-control" placeholder={t('profile.childName')}/>
													{error && error.child_name && <span className="required">{error.child_name}</span>}
												</div>
											</div>
											<div className="col-lg-6 col-md-12 admin-flatpicker">
												<div className=" form-group">
													<label>{t('profile.childAge')}</label>
													{/* <input type="Date" 
													onChange={(e) => {
														handleChange(e);
														// Dynamically update EDD minimum value based on selected DOB
														if (e.target.name === 'child_dob') {
															const dob = new Date(e.target.value);
															dob.setDate(dob.getDate() + 1); // Set EDD to be at least one day after DOB
															document.getElementsByName('child_expected_dob')[0].min = dob.toISOString().split('T')[0];
														}
													}} 
													value={data.child_dob?data.child_dob:''} name="child_dob" className="form-control admin-date-input" placeholder="DOB" max={new Date().toISOString().split("T")[0]}/> */}
													<div className="input-group">
														<Flatpickr
															value={data.child_dob || ''} // Use child_dob value
															name="child_dob"
															onChange={(selectedDates) => {
																const dobValue = selectedDates[0]; // Selected date
																if (dobValue) {
																	// Update child_dob and dynamically calculate next day's date
																	const dobFormatted = dobValue.toISOString().split("T")[0];
																	handleChange({
																		target: {
																			name: "child_dob",
																			value: dobValue,
																		},
																	});
																	
																	// Calculate and set minDate for expected DOB
																	const nextDay = new Date(dobValue);
																	nextDay.setDate(nextDay.getDate() + 1);
																	const nextDayFormatted = nextDay.toISOString().split("T")[0];
																	
																	setData((prevData) => ({
																		...prevData,
																		child_expected_dob_min: nextDay.toISOString().split("T")[0],
																	}));
																}
															}}
															options={{
																dateFormat: "Y-m-d", // Format of the date
																maxDate: "today", // Disallow future dates
															}}
															placeholder={t('profile.selectDate')} // Placeholder text
															className="form-control"
															ref={dobflatpickrRef}
														/>
														<span
															className="input-group-text input-button"
															title="toggle"
															onClick={() => dobflatpickrRef.current.flatpickr.open()}
														>
															<i className="ri-calendar-line"></i>
														</span>
													</div>
													{error && error.child_dob && <span className="required">{error.child_dob}</span>}
												</div>
											</div>
											<div className="col-lg-6 col-md-12">
												<div className=" form-group">
														<label>{t('profile.childPremature')}</label>
														<div className="form-group">
															<div className='checkRadio-bg'>
																<div className="form-check form-check-inline">
																	<input onChange={handleChange} checked={data.child_isPremature === 'true'} className="form-check-input admin-form-check-input" type="radio" name="child_isPremature" id="yesornoOptions5a" value="true" />
																	<label className="form-check-label" htmlFor="yesornoOptions5a"> Yes</label>
																</div>
																<div className="form-check form-check-inline">
																	<input onChange={handleChange} checked={data.child_isPremature === 'false'} className="form-check-input admin-form-check-input" type="radio" name="child_isPremature" id="yesornoOptions5b" value="false" />
																	<label className="form-check-label" htmlFor="yesornoOptions5b"> No</label>
																</div>
															</div>
															{error && error.child_isPremature && <span className="required">{error.child_isPremature}</span>}
														</div>
												</div>
											</div>
											{data.child_isPremature === 'true' && (
											<>
												<div className="col-lg-6 col-md-12 admin-flatpicker">
													<div className=" form-group">
														<label>{t('profile.delivaryDate')}</label>
														{/* <input type="Date" onChange={handleChange} value={data.child_expected_dob?data.child_expected_dob:''} name="child_expected_dob" className="form-control admin-date-input" placeholder="DOB" 
														// Dynamically set `min` based on DOB logic
														min={data.child_dob ? new Date(new Date(data.child_dob).setDate(new Date(data.child_dob).getDate() + 1)).toISOString().split("T")[0] : new Date().toISOString().split("T")[0]} 
														/> */}
														<div className="input-group">
															{console.log("data.child_expected_dob",data.child_expected_dob)}
															<Flatpickr
																// value={data.child_expected_dob?data.child_expected_dob:''} 
																value={data?.child_expected_dob || ''} // Use child_dob value
																name="child_expected_dob"
																onChange={(selectedDates) => {
																	const deliveryDate = selectedDates[0]; // Selected date
																	if (deliveryDate) {
																		const deliveryFormatted = deliveryDate.toISOString().split("T")[0];
																		handleChange({
																			target: {
																				name: "child_expected_dob",
																				value: deliveryDate,
																			},
																		});
																	}
																}}
																options={{
																	dateFormat: "Y-m-d", // Format of the date
																	minDate: data.child_expected_dob_min || new Date().toISOString().split("T")[0], // Dynamic minDate
																}}
																placeholder={t('profile.selectDate')}
																className="form-control"
																ref={eddflatpickrRef}
															/>
															<span
																className="input-group-text input-button"
																title="toggle"
																onClick={() => eddflatpickrRef.current.flatpickr.open()}
															>
																<i className="ri-calendar-line"></i>
															</span>
														</div>
														{error && error.child_expected_dob && <span className="required">{error.child_expected_dob}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-12">
													<div className=" form-group">
														<label>{t('profile.childWeek')}</label>
														<input disabled type="text" onChange={handleChange} value={data.child_premeture_week?data.child_premeture_week:''} name="child_premeture_week" className="form-control" placeholder= {t('profile.childWeek')}/>
														{error && error.child_premeture_week && <span className="required">{error.child_premeture_week}</span>}
													</div>
												</div>
											</>
											)}
											<div className="col-lg-6 col-md-12">
												<div className=" form-group">
													<label>{t('profile.gender')}</label>
													<select name="child_gender" value={data?.child_gender?data.child_gender:''} onChange={handleChange} className="form-select">
													<option value='' disabled>{t('profile.selectGender')}</option>
													<option value="0" >{t('profile.male')}</option>
													<option value="1" >{t('profile.female')}</option>
													</select>
													{error && error.child_gender && <span className="required">{error.child_gender}</span>}
												</div>
											</div>
											<div className="col-lg-6 col-md-12">
												<div className=" form-group">
													<label>{t('table.bloodGroup')}</label>
													<select name="child_blood_group" className="form-select" value={data.child_blood_group?data.child_blood_group:''} onChange={handleChange}>
														<option value='' disabled>{t('profile.selectBloodGroup')}</option>
														<option value="A+">A+</option>
														<option value="A-">A-</option>
														<option value="B+">B+</option>
														<option value="B-">B-</option>
														<option value="O+">O+</option>
														<option value="O-">O-</option>
														<option value="AB+">AB+</option>
														<option value="AB-">AB-</option>
													</select>
													{/* {error && error.child_blood_group && <span className="required">{error.child_blood_group}</span>} */}
												</div>
											</div>		
											<div className="col-lg-12 col-md-12">
												<div className=" form-group">
													<label>{t('table.notes')}</label>
													 <textarea onChange={handleChange} name="child_notes" value={data.child_notes?data.child_notes:''} className="form-control" rows="4"></textarea>
												</div>
											</div>
										</div>
										{/* <!--Prev-Next Button Section--> */}
										<div className="row mt-3">								
											<div className="col-lg-12 text-end">
											<button onClick={goNext(0)} type="button" className="btn btn-tmAquaGreen btnNext"><i className="iconly-Light-ArrowRight align-middle"></i> {t('profile.next')}</button>
											</div>
										</div>
									</form>
								</div>}
								
								{/* <!--TAB-02--> */}
								{tab === 1 && <div>
										<form autoComplete="off">
											<div className="row">
												<div className="col-lg-5 col-md-6">
													<div className=" form-group">
														<label>{t('profile.firstName')}</label>
														<input name="first_name" onChange={handleChange} value={data.first_name ? data.first_name.trim() : ''} type="text" className="form-control" placeholder={t('profile.firstName')} />
														{error && error.first_name && <span className="required">{error.first_name}</span>}
													</div>
												</div>
												<div className="col-lg-5 col-md-6">
													<div className=" form-group">
														<label>{t('profile.lastName')}</label>
														<input name="last_name" onChange={handleChange} value={data.last_name ? data.last_name.trim() : ''} type="text" className="form-control" placeholder={t('profile.lastName')} />
														{error && error.last_name && <span className="required">{error.last_name}</span>}
													</div>
												</div>
												<div className="col-lg-2 col-md-6">
													<div className=" form-group">
														<label>{t('profile.familyMember')}</label>
														<input name="members" maxLength={2} onChange={handleChange} value={data.members ? data.members : ''} type="text" className="form-control" placeholder="Ex. 2" />
														{error && error.members && <span className="required">{error.members}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.phoneNumber')}</label>
														<PhoneInput
															inputProps={{
																name: 'mobileNumber',
																style: { width: '100%' }
															}}
															value={data?.mobileNumberWithCode ? data?.mobileNumberWithCode : ''}
															country={'us'}
															onChange={handlePhone}
														/>
														{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
														{!isValid && !error.mobileNumber && <span className="required">{t('error.validPhoneNumber')}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.emailAddress')}</label>
														<input name="email" onChange={handleChange} value={data.email ? data.email : ''} type="text" className="form-control" placeholder="youremail@mail.com" />
														{error && error.email && <span className="required">{error.email}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.relation')}</label>
														<select name="gender" value={data?.gender !== undefined && data?.gender !== null ? String(data.gender) : ''}  onChange={handleChange} className="form-select">
															<option value='' disabled>{t('common.relation')}</option>
															<option value="0" >{t('profile.father')}</option>
															<option value="1" >{t('profile.mother')}</option>
														</select>
														{error && error.gender && <span className="required">{error.gender}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressOne')}</label>
														<input name="address_one" onChange={handleChange} value={data.address_one ? data.address_one : ''} type="text" className="form-control" placeholder={t('common.addressLine1')} />
														{error && error.address_one && <span className="required">{error.address_one}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressTwo')}</label>
														<input name="address_two" value={data.address_two ? data.address_two : ''} onChange={handleChange} type="text" className="form-control" placeholder={t('common.addressLine2')} />
														{error && error.address_two && <span className="required">{error.address_two}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.city')} </label>

														<Autocomplete
															value={data?.city ? data.city : ''}
															className="form-control"
															placeholder={t('common.city')}
															onChange={changeCity}
															onPlaceSelected={selectCity}
															types={['(cities)']}
														/>
														{error && error.city && <span className="required">{error.city}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.state')} </label>
														<input name="state" readOnly value={data.state ? data.state : ''} onChange={handleChange} type="text" className="form-control" placeholder={t('common.state')} />
														{error && error.state && !data.state && <span className="required">{error.state}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.zipCode')} </label>
														<input name="zipcode" onChange={handleChange} type="text" value={data.zipcode ? data.zipcode.trim() : ''} className="form-control" placeholder={t('common.zipCode')} />
														{error && error.zipcode && <span className="required">{error.zipcode}</span>}
													</div>
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row">								
												<div className="col-lg-12 text-end">
													<button onClick={()=>setTab(0)} type="button" className="btn btn-tmAquaDgreen btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
													<button onClick={goNext(1)} type="button" className="btn btn-tmAquaGreen btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
												</div>
											</div>
										</form>
									</div>}
								
								{/* <!--TAB-03--> */}
								{tab === 2 && <div>
									<form autoComplete="off">
										<div className="row">																						
											<div className="col-lg-12">
											<div className="row">
												<div className="col-lg-6 col-md-6 mb-3">
													<label>Physician </label>
													{/*<select
														className="form-select"
														name="physicianId"
														value={data.physicianId || ''}
														onChange={handleChange}
													>
														<option value=''>-- Select Physician --</option>
														{physicianInfo.map(Physician => (
															<option key={Physician.account} value={Physician.account}>
																Dr. {Physician.first_name} {Physician.last_name}
															</option>
														))}
													</select>*/}
													<Select
														value={
															physicianInfo
																.filter(option => option.account === data.physicianId)
																.map(option => ({
																	value: option.account,
																	label: `Dr. ${option.first_name} ${option.last_name}`,
																}))[0] || null
														}
														name="physicianId"
														onChange={(selectedOption) =>
															handleChange({
																target: { name: 'physicianId', value: selectedOption?.value },
															})
														}
														options={
															physicianInfo.map(Physician => ({
																value: Physician.account,
																label: `Dr. ${Physician.first_name} ${Physician.last_name}`,
															}))
														}
														placeholder= {t('common.selectPhysician')}
														classNamePrefix="react-select"
													/>
												</div>
											</div>	
											{data.physicianId && (
												<div className="secContent">
													<div className="table-responsive">
													<table className="table table-borderless theme-table">
														<thead>
														<tr>
															<th scope="col">{t('profile.visitingDays')}</th>
															<th scope="col">{t('profile.visitingHours')}</th>
															<th scope="col">{t('profile.consultingDuration')}</th>
														</tr>
														</thead>
														<tbody>
														{filteredSchedules.length > 0 ? (
															filteredSchedules.map((item, i) => (
															<tr className="text-capitalize" key={i}>
																<td className="prty-td">
																<h5 className="table-title">
																	{item.days.length > 0 ? item.days.join(", ") : "--"}
																</h5>
																</td>
																<td>
																	{item?.startTime ? convertTimeFormat(item?.startTime) : '--'}
																	{item?.startTime && item?.endTime && ' to '}
																	{item?.endTime && convertTimeFormat(item?.endTime)}
																</td>
																<td className="text-center">
																	{item.consultingDuration}
																</td>
															</tr>
															))
														) : (
															<tr>
															<td colSpan="2" className="text-center">
																{t('common.noRecord')}
															</td>
															</tr>
														)}
														</tbody>
													</table>
													</div>
												</div>
												)}	
											</div>	
										</div>
										{/*Prev-Next Button Section*/}
										<div className="row">								
											<div className="col-lg-12 text-end">
												<button onClick={()=>setTab(1)} type="button" className="btn btn-tmAquaDgreen btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
												<button onClick={handleSubmit} type="button" className="btn btn-tmAquaGreen" ><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
											</div>
										</div>
									</form>
								</div>}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	{/* /* <!-- End Page Content Section --> */ }
	</main>
     );
    };
    export default EditChildren;
